import React from "react"
import Layout from "../components/layout"
import { injectIntl } from "gatsby-plugin-intl"
import Banner from "../includes/partner/banner"
import Advantage from "../includes/partner/advantages"
import Numbers from "../includes/partner/numbers"
import Coop from "../includes/partner/coop"
import Steps from "../includes/partner/steps"
import Actions from "../includes/partner/actions"
import Brands from "../includes/partner/brands"
import { defaultIntl } from "../utils"

const PartnerPage = ({ intl = defaultIntl }) => (
  <Layout intl={intl} page="partner">
    <Banner intl={intl} />
    <Advantage intl={intl} />
    <Numbers intl={intl} />
    <Coop intl={intl} />
    <Steps intl={intl} />
    <Actions intl={intl} />
    <Brands intl={intl} />
  </Layout>
)

export default injectIntl(PartnerPage)
